import React from 'react';
import { Select } from '@input';
import { keys, creditScoreRanges, fieldTypes } from '@enums';

const options = Object.values(creditScoreRanges);

function CreditScore(props) {
  return (
    <Select
      label="Credit Score"
      className="input-credit-score"
      fieldClassName="field-credit-score"
      name={keys.CREDIT_SCORE}
      optionsMinWidth={220}
      maxWidth={220}
      options={options}
      {...props}
    />
  );
}

function validate(value) {
  if (isNaN(value)) {
    return 'Please select a credit score';
  }

  if (!options.find(o => value === o.value)) {
    return 'Invalid credit score';
  }
}

export default { Component: CreditScore, validate, type: fieldTypes.SELECT };
